import React from "react";
import MtiButton from "../../Buttons/MtiButton";

type Props = {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  variant?: "primary" | "secondary" | "tertiary";
  colorVariant? : "default" | "alternate" | "success" | "error" | "black";
};

const ToolsContentButton = ({
  text,
  disabled = false,
  onClick = () => {},
  style = {},
  variant,
  colorVariant,
}: Props) => {
  return (
    <MtiButton
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      colorVariant={colorVariant}
      style={{
        minWidth: 87,
        width: "auto",
        fontWeight: 500,
        fontSize: 12,
        padding: "8px 12px",
        textAlign: "center",
        textTransform: "uppercase",
        marginLeft: 4.5,
        marginRight: 4.5,
        ...style,
      }}
    >
      {text}
    </MtiButton>
  );
};

export default ToolsContentButton;
